import { Route } from 'config/routes';
import { put, select, takeEvery } from 'redux-saga/effects';
import { setMenuDotVisible } from 'store/state/app/actions';
import { isMenuDotVisibleSelector } from 'store/state/app/selectors';
import { TRANSITION_SUCCESS } from 'store/state/router/types';
import { routeSelector } from 'store/state/selectors/router';

function* resetMenuDotWorker() {
  const route = yield select(routeSelector);
  const isMenuDotVisible = yield select(isMenuDotVisibleSelector);

  if (route.name === Route.SavedSearchesPage && isMenuDotVisible) {
    yield put(setMenuDotVisible(false));
  }
}

export function* menuDotWatcher() {
  yield takeEvery(TRANSITION_SUCCESS, resetMenuDotWorker);
}
